// Refreshes the product media gallery when a variant change requires
// a section update. Horizon's variant picker dispatches a custom event
// that we listen for; we trigger a fetch + replace of the media gallery.

(function () {
  'use strict';

  const SECTION_RENDER_URL = (sectionId, variantId) =>
    `${window.location.pathname}?section_id=${sectionId}&variant=${variantId}`;

  function refreshGallery(sectionId, variantId) {
    if (!sectionId) return;

    fetch(SECTION_RENDER_URL(sectionId, variantId))
      .then((res) => res.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newGallery = doc.querySelector('media-gallery');
        const currentGallery = document.querySelector('media-gallery');

        if (newGallery && currentGallery) {
          currentGallery.replaceWith(newGallery);
        }
      })
      .catch((err) => {
        console.warn('Variant gallery refresh failed:', err);
      });
  }

  // Listen for variant changes. Horizon emits 'variant:change' on the
  // variant-picker component when the customer selects a new variant.
  document.addEventListener('variant:change', function (event) {
    const variantId = event.detail?.variant?.id;
    const sectionId = event.target.closest('[data-section-id]')?.dataset.sectionId
      || document.querySelector('media-gallery')?.closest('[data-section]')?.dataset.section;

    if (variantId) {
      refreshGallery(sectionId, variantId);
    }
  });
})();